import BaseService from "dev/packages/BaseService";
import axios from "src/packages/MyAxios";


export default class QuestionLessonService extends BaseService {
	static addGame (question_id, game_id) 
	{
		const data = {
			"question_id" :question_id,
			"game_id" : game_id
		};
		data._method = "put";

		return axios.post("question/add-game", data).then(
		  (response) => {
			return response.data;
		  }
		);
	  }
	static get className() {
		return "questions";
	}
};
